import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

export let insightsInstance

export function createAppInsights({
    deviceToken,
    history,
    instrumentationKey
}) {
    const reactPlugin = new ReactPlugin()
    const appInsightsInstance = new ApplicationInsights({
        config: {
            disableDataLossAnalysis: false,
            disableFetchTracking: false,
            enableAjaxErrorStatusText: true,
            enableAjaxPerfTracking: true,
            enableCorsCorrelation: true,
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
            excludeRequestForAutoTrackingPatterns: [/hotjar/, /hot-update/, /ga/],
            extensionConfig: {
                [reactPlugin.identifier]: { history }
            },
            extensions: [reactPlugin],
            instrumentationKey,
            isBeaconApiDisabled: !(navigator && typeof navigator.sendBeacon === 'function'),
            loggingLevelConsole: 2
        }        
    })

    appInsightsInstance.loadAppInsights()
    appInsightsInstance.addTelemetryInitializer(envelope => {
        envelope.data['source'] = 'web'
        envelope.data['uiApplicationID'] = 'enroll'
        envelope.data['deviceToken'] = deviceToken
    })

    insightsInstance = appInsightsInstance
}

export function getAppInsights() {
    return insightsInstance.appInsights
}